define( [
	"../var/support"
], function( support ) {

"use strict";

support.focusin = "onfocusin" in window;

return support;

} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/event/support.js
// module id = 106
// module chunks = 0